import { IInsightsTrends } from '../../../common/models/Insights'
import { GET_INSIGHTS_TRENDS } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (
  termNumber: number,
  token: string,
  memberIds?: string[] | undefined
) =>
  fetch(GET_INSIGHTS_TRENDS(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({ memberIds }),
  })
    .then(errorHandler)
    .then(
      async (response: Response): Promise<IInsightsTrends> => {
        const result = await response.json()
        return result
      }
    )
